module.exports = __webpack_public_path__ + "static/media/carpenter.890f3150.jpg";